/**
 * Sistemos pavadinimas — VIENOJE vietoje.
 *
 * Iki šiol „Klaipėdos Kranai" buvo įrašytas 19-oje failų: prisijungimo lange,
 * meniu, PDF dokumentuose, el. laiškuose. Demonstracijai kitiems klientams to
 * ženklo matytis negali, o keisti 19 vietų prieš kiekvieną filmavimą nerealu.
 *
 * Gamyboje kintamasis nenustatytas → lieka „Klaipėdos Kranai", elgesys
 * nesikeičia. Demo stack'e `NEXT_PUBLIC_APP_NAME` nustato neutralų pavadinimą.
 *
 * NEXT_PUBLIC_ prefiksas būtinas: pavadinimas naudojamas ir naršyklės pusėje
 * (meniu, prisijungimas), o toks kintamasis įrašomas build metu.
 */
export const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME || 'Klaipėdos Kranai'

/** Trumpas variantas antraštėms ir el. laiškų parašams. */
export const APP_SHORT = process.env.NEXT_PUBLIC_APP_NAME || 'Klaipėdos Kranai'

/**
 * Ar veikia SAVAS (ne Klaipėdos Kranų) ženklas — t.y. demonstracinis stack'as.
 *
 * Naudojama piktogramoms: `/icons/[size]` jas generuoja iš `logo.png`, kuris yra
 * KLIENTO logotipas. Filmuojant jis matytųsi naršyklės kortelėje, nors visas
 * tekstas jau neutralus. Kai ženklas savas — piešiam paprastą neutralią ikoną.
 */
export const IS_CUSTOM_BRAND = Boolean(process.env.NEXT_PUBLIC_APP_NAME)
